import h from "./extends3.mjs";
import * as V from "react";
import { useOpenState as Y } from "./useOpenState.mjs";
import { useUtils as Z, useLocalizationContext as ee } from "./useUtils.mjs";
import { useValidation as te } from "./useValidation.mjs";
import { useValueWithTimezone as oe } from "./useValueWithTimezone.mjs";
import ne from "./useControlled.mjs";
import l from "./useEventCallback.mjs";
const le = (a) => {
  const {
    action: t,
    hasChanged: s,
    dateState: u,
    isControlled: d
  } = a, i = !d && !u.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? i && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : s(u.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? i ? !0 : s(u.lastPublishedValue) : !1;
}, ae = (a) => {
  const {
    action: t,
    hasChanged: s,
    dateState: u,
    isControlled: d,
    closeOnSelect: i
  } = a, S = !d && !u.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? S && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : s(u.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && i ? S ? !0 : s(u.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && s(u.lastCommittedValue) : !1;
}, se = (a) => {
  const {
    action: t,
    closeOnSelect: s
  } = a;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && s : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, Ve = ({
  props: a,
  valueManager: t,
  valueType: s,
  wrapperVariant: u,
  validator: d
}) => {
  const {
    onAccept: i,
    onChange: S,
    value: o,
    defaultValue: A,
    closeOnSelect: R = u === "desktop",
    selectedSections: x,
    onSelectedSectionsChange: b,
    timezone: B
  } = a, {
    current: p
  } = V.useRef(A), {
    current: C
  } = V.useRef(o !== void 0);
  process.env.NODE_ENV !== "production" && (V.useEffect(() => {
    C !== (o !== void 0) && console.error([`MUI: A component is changing the ${C ? "" : "un"}controlled value of a picker to be ${C ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [o]), V.useEffect(() => {
    !C && p !== A && console.error(["MUI: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(p)]));
  const m = Z(), g = ee(), [U, q] = ne({
    controlled: x,
    default: null,
    name: "usePickerValue",
    state: "selectedSections"
  }), {
    isOpen: k,
    setIsOpen: P
  } = Y(a), [r, E] = V.useState(() => {
    let e;
    return o !== void 0 ? e = o : p !== void 0 ? e = p : e = t.emptyValue, {
      draft: e,
      lastPublishedValue: e,
      lastCommittedValue: e,
      lastControlledValue: o,
      hasBeenModifiedSinceMount: !1
    };
  }), {
    timezone: F,
    handleValueChange: M
  } = oe({
    timezone: B,
    value: o,
    defaultValue: p,
    onChange: S,
    valueManager: t
  });
  te(h({}, a, {
    value: r.draft,
    timezone: F
  }), d, t.isSameError, t.defaultErrorState);
  const c = l((e) => {
    const n = {
      action: e,
      dateState: r,
      hasChanged: (f) => !t.areValuesEqual(m, e.value, f),
      isControlled: C,
      closeOnSelect: R
    }, v = le(n), z = ae(n), X = se(n);
    if (E((f) => h({}, f, {
      draft: e.value,
      lastPublishedValue: v ? e.value : f.lastPublishedValue,
      lastCommittedValue: z ? e.value : f.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    })), v) {
      const I = {
        validationError: e.name === "setValueFromField" ? e.context.validationError : d({
          adapter: g,
          value: e.value,
          props: h({}, a, {
            value: e.value,
            timezone: F
          })
        })
      };
      e.name === "setValueFromShortcut" && e.shortcut != null && (I.shortcut = e.shortcut), M(e.value, I);
    }
    z && i && i(e.value), X && P(!1);
  });
  if (o !== void 0 && (r.lastControlledValue === void 0 || !t.areValuesEqual(m, r.lastControlledValue, o))) {
    const e = t.areValuesEqual(m, r.draft, o);
    E((n) => h({}, n, {
      lastControlledValue: o
    }, e ? {} : {
      lastCommittedValue: o,
      lastPublishedValue: o,
      draft: o,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const N = l(() => {
    c({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), j = l(() => {
    c({
      value: r.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), _ = l(() => {
    c({
      value: r.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), $ = l(() => {
    c({
      value: r.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), J = l(() => {
    c({
      value: t.getTodayValue(m, F, s),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), L = l(() => P(!0)), y = l(() => P(!1)), w = l((e, n = "partial") => c({
    name: "setValueFromView",
    value: e,
    selectionState: n
  })), W = l((e, n, v) => c({
    name: "setValueFromShortcut",
    value: e,
    changeImportance: n ?? "accept",
    shortcut: v
  })), G = l((e, n) => c({
    name: "setValueFromField",
    value: e,
    context: n
  })), O = l((e) => {
    q(e), b?.(e);
  }), D = {
    onClear: N,
    onAccept: j,
    onDismiss: _,
    onCancel: $,
    onSetToday: J,
    onOpen: L,
    onClose: y
  }, H = {
    value: r.draft,
    onChange: G,
    selectedSections: U,
    onSelectedSectionsChange: O
  }, T = V.useMemo(() => t.cleanValue(m, r.draft), [m, t, r.draft]), K = {
    value: T,
    onChange: w,
    onClose: y,
    open: k,
    onSelectedSectionsChange: O
  }, Q = h({}, D, {
    value: T,
    onChange: w,
    onSelectShortcut: W,
    isValid: (e) => {
      const n = d({
        adapter: g,
        value: e,
        props: h({}, a, {
          value: e,
          timezone: F
        })
      });
      return !t.hasError(n);
    }
  });
  return {
    open: k,
    fieldProps: H,
    viewProps: K,
    layoutProps: Q,
    actions: D
  };
};
export {
  Ve as usePickerValue
};
//# sourceMappingURL=usePickerValue.mjs.map
